import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import { ReactSVG } from "react-svg";
import styles from "./hero.module.scss";

export const ElearningListingHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
          <Grid item xs={12} sm={6} md={6}>
            <div className={styles.heading_wrapper}>
              <h1 className={styles.heading}>
                Make your test scores skyrocket with{" "}
                <span className={"mark"}>Unisearch</span> Live
              </h1>
              <p className={styles.sub_text}>
                IELTS is an English language exam that is required to be taken
                by international candidates considering studying or working in a
                country where English is the main language of communication.
              </p>

              <div className={styles.btn_wrapper}>
                <Link legacyBehavior href="#">
                  <a
                    className={`btn btn-secondary btn-xl ${styles.action_btn}`}
                  >
                    View More
                  </a>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <div className={styles.hero_image_wrapper}>
              <ReactSVG
                src={getAssets(
                  "assets/images/elearning/listing/hero-illustration.svg"
                )}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ElearningListingHero;
